import React from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../Components/Layout/Body/index";
import { LandingPage } from "../Pages/LandingPage";
import Dashboard from "../Pages/Dashboard";
import LeadManagement from "../Pages/ContactManagement";
import CreateContact from "../Pages/CreateContact";
import ContactDetails from "../Pages/ContactDetails";
import ProtectedRoute from "./protectedRoute";

const RoutePath = ({ isDarkTheme }) => {
  return (
    <div className="App">
      <Routes>
        {/* Public Routes without Layout (no header/menu) */}

        <Route element={<Layout isDarkTheme={isDarkTheme} />}>
          {/* Public Landing Page */}
          <Route path="/" element={<LandingPage />} />

          {/* Protected Routes - Only accessible from oruclicks.com */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/contact-management" element={<LeadManagement />} />
            <Route path="/create-contact" element={<CreateContact />} />
            <Route path="/contact/:dateTimeStamp" element={<ContactDetails />} />
            <Route path="/lead/:leadId" element={<ContactDetails />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
};
export default RoutePath;
